import { Spacer, TextSubtitle } from '@pypestream/design-system';
import React, { FC, KeyboardEvent, PropsWithChildren, useState } from 'react';
import { useNavigate } from 'react-router';

import { ToolModal } from '..';
import {
  useManagerCtxSelector,
  useManagerStateMatchesOneOf,
} from '../../xstate/app.xstate';
import { ProductCTA } from '../product-cta';
import './page-header.scss';
import { TranslationComponent } from '@pypestream/translations';
import { useReleasedTools } from '../../hooks';

export const PageHeader: FC<PropsWithChildren> = () => {
  const navigate = useNavigate();
  const [selectedTool, setSelectedTool] = useState<string | undefined>();
  const { allTools } = useManagerCtxSelector((ctx) => ({
    allTools: ctx.tools,
  }));

  const shouldWaitDataLoad = !!useManagerStateMatchesOneOf([
    'orgRelated.ready.projectsNew.loading',
  ]);
  const tools = useReleasedTools(allTools);

  return (
    <>
      <TextSubtitle>
        <TranslationComponent i18nKey="manager/common:homepage.header.tools">
          Tools
        </TranslationComponent>
      </TextSubtitle>
      <Spacer size="small" />
      <div className="c-tools-grid">
        {tools.map((tool) => {
          const { logo, label, productId, url, disabled, conditional, name } =
            tool;

          const clickAction = conditional
            ? {
                ...(url
                  ? { url }
                  : {
                      onClick: () => setSelectedTool(productId),
                      onKeyDown: (e: KeyboardEvent) => {
                        if (e.key === 'Enter') setSelectedTool(productId);
                      },
                    }),
              }
            : {
                ...(url && url.includes('https')
                  ? { url }
                  : {
                      onClick: () => {
                        if (url) navigate(url);
                      },
                      onKeyDown: (e: KeyboardEvent) => {
                        if (url && e.key === 'Enter') navigate(url);
                      },
                    }),
              };

          return (
            <div key={label}>
              <ProductCTA
                test-id={`product-cta-${label?.replace(' ', '-').toLowerCase()}`}
                logo={logo}
                name={label}
                disabled={disabled || shouldWaitDataLoad}
                productName={name}
                width="full"
                {...clickAction}
              />
            </div>
          );
        })}
      </div>
      <Spacer size="large" />
      <ToolModal
        open={!!selectedTool}
        tools={tools}
        selectedTool={selectedTool}
        onClose={() => setSelectedTool(undefined)}
      />
    </>
  );
};
